import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'systemcode-payment-redirect',
  templateUrl: './payment-redirect.component.html',
  styleUrls: ['./payment-redirect.component.scss'],
})
export class PaymentRedirectComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  public constructor(
    private route:ActivatedRoute,
  ) {}

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.destroyed$)).subscribe(queryParams => {
      const mtpl = sessionStorage.getItem('mtpl');
      const travel = sessionStorage.getItem('travel');
      const PropertyInsuranceData = sessionStorage.getItem('PropertyInsuranceData');
      const policyPayment = sessionStorage.getItem('policy-payment');
      const lang = sessionStorage.getItem('old_lang');
      //const langPath = lang === 'en' ? '/en' : '';
      //this.onLangChange(lang);
      //sessionStorage.setItem('lang',lang.toLowerCase());
   
    
      const locationStrArray = window.location.href.toString().split('/')
      const hostUrl = locationStrArray[0] + '//' + window.location.host;
      console.log(lang)
      console.log(hostUrl)

      if (queryParams.success === '1') {
        if (mtpl !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/mtpl/purchase-policy/payment?success=1`);
          }else{
            window.location.replace(hostUrl+`/mtpl/purchase-policy/payment?success=1`);
          }
          // this.router.navigateByUrl('/mtpl/purchase-policy/payment?success=1');
        } else if (travel !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/travel/purchase-policy/travel-payment?success=1`);
          }else{
            window.location.replace(hostUrl+`/travel/purchase-policy/travel-payment?success=1`);
          }
          // this.router.navigateByUrl('/travel/purchase-policy/travel-payment?success=1');
        } else if (PropertyInsuranceData !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/property-insurance/purchase-policy/payment?success=1`);
          }else{
            window.location.replace(hostUrl+`/property-insurance/purchase-policy/payment?success=1`);
          }
          // this.router.navigateByUrl('/property-insurance/purchase-policy/payment?success=1');
        } else if (policyPayment !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/policy-payment/payment-result?success=1`);
          }else{
            window.location.replace(hostUrl+`/policy-payment/payment-result?success=1`);
          }
          // this.router.navigateByUrl('/policy-payment/payment-result?success=1');
          
        }
      } else if (queryParams.success === '0') {
        if (mtpl !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/mtpl/purchase-policy/payment-result?success=0`);
          }else{
            window.location.replace(hostUrl+`/mtpl/purchase-policy/payment-result?success=0`);
          }
          // this.router.navigateByUrl('/mtpl/purchase-policy/payment-result?success=0');
        } else if (travel !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/travel/purchase-policy/travel-payment-result?success=0`);
          }else{
            window.location.replace(hostUrl+`/travel/purchase-policy/travel-payment-result?success=0`);
          }
          // this.router.navigateByUrl('/travel/purchase-policy/travel-payment-result?success=0');
        } else if (PropertyInsuranceData !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/property-insurance/purchase-policy/payment-error`);
          }else{
            window.location.replace(hostUrl+`/property-insurance/purchase-policy/payment-error`);
          }
          // this.router.navigateByUrl('/property-insurance/purchase-policy/payment-error');
        } else if (policyPayment !== null) {
          if(lang !=='bg'){
            window.location.replace(hostUrl+`/${lang}/policy-payment/payment-result?success=0`);
          }else{
            window.location.replace(hostUrl+`/policy-payment/payment-result?success=0`);
          }
          // this.router.navigateByUrl('/policy-payment/payment-result?success=0');
        }
      }
    });
  }
}
